import homePayload from "./HomePayload";
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import * as DashboardConstants from '../../Dashboards/DashboardConstants';

let count = {
    range1: 0,
    range2: 0,
    range3: 0,
    range4: 0,
    range5: 0,
    range6: 0,
    range7: 0,
}

export async function SuccessRate(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = []; let guageData = [];
        return callPostApi(Constants.GETSUCCESSRATE, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareSuccessRateData(resp);
                guageData = prepareGuageChartData(formattedData);
                return { data: guageData ? guageData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareSuccessRateData = (response) => {
    let buckets = [];
    let avgSucessRate = 0;
    let successRatePercentage = {};
    if (response?.aggregations) {
        buckets = response?.aggregations?.priority?.buckets;
        if (buckets.length) {
            for (let i = 0; i < buckets.length; i++) {
                avgSucessRate = (avgSucessRate + ((buckets[i].Completions.value / (buckets[i].doc_count - buckets[i].ReRuns.value + buckets[i].SchdMiss.value)) * 100));
            }
            successRatePercentage = { avgSucessRate: avgSucessRate ? (avgSucessRate / buckets.length) : 0 };
        }
    }

    return successRatePercentage;
};

const prepareGuageChartData = (response) => {
    let value = {}; let GraphData = [];
    if (Object.keys(response).length) {
        value = response.avgSucessRate;
        GraphData = [
            {
                "group": "value",
                "value": value
            }
        ];
    }

    return GraphData;
}

export async function BotSummary(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETBOTSUMMARYSHAREDPROD, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareBotSummaryReportData(resp);
                return { data: formattedData.tableData ? formattedData.tableData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareBotSummaryReportData = (response) => {
    let tableObj = {};
    let tableData = [];
    let reRuns;

    if (response?.aggregations) {
        let buckets = response?.aggregations?.BOTID?.buckets;
        for (let i = 0; i < buckets.length; i++) {
            let leadPlatformBucket = buckets[i].LeadPlatform.buckets;
            for (let j = 0; j < leadPlatformBucket.length; j++) {
                let subAreaBucket = leadPlatformBucket[j].SubArea.buckets;
                for (let k = 0; k < subAreaBucket.length; k++) {
                    let srvcprocessNameBucket = subAreaBucket[k].Service_prc_name.buckets;
                    for (let l = 0; l < srvcprocessNameBucket.length; l++) {
                        let processNameBucket = srvcprocessNameBucket[l].ProcessName.buckets
                        for (let m = 0; m < processNameBucket.length; m++) {
                            let geographyBucket = processNameBucket[m].Geography.buckets
                            for (let n = 0; n < geographyBucket.length; n++) {
                                let processCriticalityBucket = geographyBucket[n].ProcessCriticality.buckets;
                                for (let o = 0; o < processCriticalityBucket.length; o++) {
                                    let technologyBucket = processCriticalityBucket[o].Technology.buckets;
                                    for (let p = 0; p < technologyBucket.length; p++) {
                                        let deliveryModelBucket = technologyBucket[p].DeliveryModel.buckets;
                                        for (let q = 0; q < deliveryModelBucket.length; q++) {
                                            let supportStatusBucket = deliveryModelBucket[q].SupportStatus.buckets;
                                            for (let r = 0; r < supportStatusBucket.length; r++) {
                                                tableObj = {
                                                    id: ((i + j + k + 1).toString()) + Math.random(1),
                                                    botId: buckets[i].key,
                                                    leadPlatform: leadPlatformBucket[j].key ? leadPlatformBucket[j].key : 0,
                                                    subArea: subAreaBucket[k].key ? subAreaBucket[k].key : 0,
                                                    processName: processNameBucket[m].key ? processNameBucket[m].key : 0,
                                                    geo: geographyBucket[n].key ? geographyBucket[n].key : 0,
                                                    processCritical: processCriticalityBucket[o].key ? processCriticalityBucket[o].key : 0,
                                                    requestedBy: technologyBucket[p].key ? technologyBucket[p].key : 0,
                                                    deliveryModel: deliveryModelBucket[q].key ? deliveryModelBucket[q].key : 0,
                                                    supportStatus: supportStatusBucket[r].key ? supportStatusBucket[r].key : 0,
                                                    completions: supportStatusBucket[r].Completions.value ? supportStatusBucket[r].Completions.value : 0,
                                                    schMisses: supportStatusBucket[r].SchedulerMisses.value ? supportStatusBucket[r].SchedulerMisses.value : 0,
                                                    terminations: supportStatusBucket[r].Terminations.value ? supportStatusBucket[r].Terminations.value : 0,
                                                }
                                                reRuns = supportStatusBucket[r].ReRuns.value ? supportStatusBucket[r].ReRuns.value : 0;
                                                tableObj.totalRuns = processNameBucket[m].doc_count ? processNameBucket[m].doc_count : 0;
                                                tableObj.reruns = reRuns;
                                                tableObj.successRate = supportStatusBucket[r].Completions.value > 0 ? (((supportStatusBucket[r].Completions.value / (processNameBucket[m].doc_count - reRuns + supportStatusBucket[r].SchedulerMisses.value)) * 100).toFixed(2)) + '%' : 0;
                                                tableData.push(tableObj);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return { tableData };
};


export async function QueuePerformanceData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETQUEUEPERFORMANCE, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareQueuePerformanceData(resp);
                return { data: formattedData.tableData ? formattedData.tableData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareQueuePerformanceData = (response) => {
    let tableData = [];
    let tableObj = {};
    if (response?.aggregations) {
        let buckets = response?.aggregations.QueueName.buckets;
        for (let i = 0; i < buckets.length; i++) {
            tableObj = {
                id: i + 1,
                QueueName: buckets[i].key,
                AvgProcessTime: (buckets[i]["1"].value / 60).toFixed(3),
                AvgHandlingTime: (buckets[i].AvgHandlingTime.value / 60).toFixed(3),
                Avgretries: (buckets[i].Avgretries.value).toFixed(3),
            };
            tableData.push(tableObj);
        }
    }
    return { tableData };
};

export async function AccuracyReportTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETQUEUEACCURACYREPORT, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = preparePerformanceTrendData(resp);
                return { data: formattedData.tableData ? formattedData.tableData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

export async function FirstTimeRun(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETFIRSTTIMERUN, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = preparePerformanceTrendData(resp);
                return { data: formattedData.tableData ? formattedData.tableData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const preparePerformanceTrendData = (response) => {
    let tableData = [];
    let tableObj = {};
    if (response?.aggregations) {
        let buckets = response?.aggregations?.AutomataName?.buckets;
        if (buckets.length > 0) {
            for (let i = 0; i < buckets.length; i++) {
                let botvalue = ((buckets[i].CompletedItem.value + buckets[i].BusinessException.value) / (buckets[i].CompletedItem.value + buckets[i].SystemException.value + buckets[i].BusinessException.value)) * 100
                let sum = 0;
                sum = sum + buckets[i].CompletedItem.value + buckets[i].ItemPending.value + buckets[i].running.value + buckets[i].BusinessException.value + buckets[i].SystemException.value;
                tableObj = {
                    id: i + 1,
                    ProcessName: buckets[i].key,
                    NoofItem: buckets[i].doc_count,
                    ItemPending: buckets[i].ItemPending.value,
                    CompletedItem: buckets[i].CompletedItem.value,
                    SystemException: buckets[i].SystemException.value,
                    AvgHandlingTime: buckets[i].AvgHandlingTime.value,
                    BusinessException: buckets[i].BusinessException.value,
                    AvgProcessingTime: buckets[i].AvgProcessingTime.value,
                    running: buckets[i].running.value,
                    Others: buckets[i].doc_count - sum,
                    botaccuracy: botvalue ? botvalue.toFixed(2) + '%' : '-'
                };
                tableData.push(tableObj);
            }
        }
    }
    return { tableData };
};

export async function TerminationRateTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETTERMINATIONRATETREND, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareTerminationRateTrendData(resp);
                return { data: formattedData ? formattedData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareTerminationRateTrendData = (response) => {
    let data = [];
    let obj = {};
    if (response?.aggregations) {
        let buckets = response?.aggregations["4"]?.buckets;
        for (let i = 0; i < buckets.length; i++) {
            for (let j = 0; j < buckets[i]["5"].buckets.length; j++) {
                obj = {
                    group: buckets[i]["5"].buckets[j].key,
                    date: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
                    value: (buckets[i]["5"].buckets[j]["3"].value).toFixed(2)
                }
                data.push(obj);
            }
        }
    }
    return data;
};

export async function AutomataStartsOnTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.AUTOMATASTARTSONTIME, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareAutomataGuageChartData(resp, DashboardConstants.AutomataStartsOnTimeMetrics);
                return { data: formattedData ? formattedData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareAutomataGuageChartData = (response, type) => {
    let GraphData = [], resolutionTime = {};
    if (response?.aggregations) { resolutionTime = response?.aggregations; }
    let value = {};
    switch (type) {
        case DashboardConstants.AutomataRunsOnTimeMetrics:
            value = resolutionTime.automata_runs_on_time.value === null ? 0 : resolutionTime.automata_runs_on_time.value;
            break;
        case DashboardConstants.AutomataStartsOnTimeMetrics:
            value = resolutionTime.automata_starts_on_time.value === null ? 0 : Math.round(resolutionTime.automata_starts_on_time.value);
            break;
        default: break;
    }
    GraphData = [
        {
            "group": "value",
            "value": value
        }
    ];

    return GraphData;
}

export async function AutomataRunsOnTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.AUTOMATARUNSONTIME, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareAutomataGuageChartData(resp, DashboardConstants.AutomataRunsOnTimeMetrics);
                return { data: formattedData ? formattedData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

export async function FTESaving(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        return callPostApi(Constants.GETHOURSSAVED, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                let hoursValue = (resp?.aggregations.hours_saved.value).toFixed(2);
                return { data: isNaN(hoursValue) ? 0 : hoursValue, loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

export async function ResourceUtilization(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        return callPostApi(Constants.GETRESOURCES, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                let numberOfResources = resp?.aggregations?.number_of_resources?.value;
                let resourceUtilValue = (resp.aggregations.utilization_percentage.value / numberOfResources).toFixed(2);
                return { data: isNaN(resourceUtilValue) ? 0 : resourceUtilValue + '%', loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

export async function FirstTimeRunSuccessful(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETFIRSTTIMERUN, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                let count = prepareFirstTimeRunTable(resp);
                formattedData = Object.keys(count).length > 0 ? prepareFirstTimeRunBarData(count) : [];
                // prepareFirstTimeRunTable(resp);
                // formattedData = prepareFirstTimeRunBarData(botsCount);
                return { data: formattedData ? formattedData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

function prepareFirstTimeRunTable(resp) {
    let tableObj = {}, tableData = [];
    let botIdBuckets = resp?.aggregations.BOT_ID.buckets;
    if (botIdBuckets.length > 0) {
        botIdBuckets.map((botItem) => {
            let automataBuckets = botItem['Automata_Status'].buckets;
            automataBuckets.map((automataStatus) => {
                let FirstRunSuccessPercent = (automataStatus.First_Time_Sucessful_Run.value / automataStatus.Total_Runs.value) * 100
                tableObj = {
                    botId: botItem.key,
                    totalRuns: botItem.Total_Runs.value,
                    successOnFirstRun: automataStatus.First_Time_Sucessful_Run.value,
                    successOf1stRun: FirstRunSuccessPercent.toFixed(2),
                    status: automataStatus.key
                }
                tableData.push(tableObj);
            });
        });
        return prepareTableBarData(tableData);
    }
    else return tableData;

}

function prepareTableBarData(data) {
    data.map((items) => {
        let fillColor = '';
        let successOf1stRun = isNaN(items.successOf1stRun) || items.successOf1stRun === '0.00' ? 0 : items.successOf1stRun === '100.00' ? 100 : items.successOf1stRun;

        if ((successOf1stRun <= 25.00 || successOf1stRun <= 25) && successOf1stRun > 0) {
            fillColor = '#FA6400';
            count.range1 = count.range1 + 1;
        }
        else if ((successOf1stRun <= 50.00 || successOf1stRun <= 50) && successOf1stRun >= 25.01) {
            fillColor = '#F7B500';
            count.range2 = count.range2 + 1;
        }
        else if ((successOf1stRun <= 80.00 || successOf1stRun <= 80) && successOf1stRun >= 50.01) {
            fillColor = '#0091FF';
            count.range3 = count.range3 + 1;
        }
        else if ((successOf1stRun <= 95.00 || successOf1stRun <= 95) && successOf1stRun >= 80.1) {
            fillColor = '#32C5FF';
            count.range4 = count.range4 + 1;
        }
        else if (successOf1stRun <= 99.99 && successOf1stRun >= 95.01) {
            fillColor = '#44D7B6';
            count.range5 = count.range5 + 1;
        }
        else if (successOf1stRun === 100) {
            fillColor = '#6DD400';
            count.range6 = count.range6 + 1;
        }
        else if (successOf1stRun === 0) {
            fillColor = '#E02020';
            count.range7 = count.range7 + 1;
        }

    })
    return count;
}

function prepareFirstTimeRunBarData(data) {
    let barDataArr = [];
    barDataArr = [
        {
            "group": "0%-25%",
            "value": data.range1
        },
        {
            "group": "25%-50%",
            "value": data.range2
        },
        {
            "group": "50%-80%",
            "value": data.range3
        },
        {
            "group": "80%-95%",
            "value": data.range4
        },
        {
            "group": "95%-99.9%",
            "value": data.range5
        },
        {
            "group": "Full 100%",
            "value": data.range6
        },
        {
            "group": "0",
            "value": data.range7
        }
    ]
    return barDataArr;
}

export async function OnboardAutomataCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        return callPostApi(Constants.GETRESOURCES, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                let numberOfResources = resp?.aggregations.number_of_resources.value;
                return { data: numberOfResources ? numberOfResources : 0, loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

export async function ExceptionClassification(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETEXCEPTIONCLASSIFICATION, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareclassificationData(resp);
                return { data: formattedData ? formattedData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareclassificationData = (response) => {
    let data = [];
    let buckets = response.aggregations.count_all.buckets;
    let total = 0;
    if (buckets.length) {
        for (let i = 0; i < buckets.length; i++) {
            total = total + buckets[i]["1"].value;
        }
        for (let i = 0; i < buckets.length; i++) {
            data[i] = {
                'group': buckets[i].key,
                'value': buckets[i]["1"].value,
                'percentage': ((buckets[i]["1"].value * 100) / total).toFixed(2),
                'chartItems': [{
                    'title': DashboardConstants.Total,
                    'value': buckets[i]["1"].value
                }]
            }
        }
    }
    return data;
}

export async function TopLongRunningAutomata(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = {};
        return callPostApi(Constants.GETTOPLONGRUNNINGAUTOMATAS, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareLongRunningAutomataData(resp);
                return { data1: formattedData.graphData ? formattedData.graphData : [], loader: false, data2: formattedData.summary ? formattedData.summary : 0 };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareLongRunningAutomataData = (response) => {
    let graphData = [];
    let tableObj = {};
    let graphObj = {};
    let downloadableData = [];
    let summary = 0;
    if (response?.aggregations) {
        let buckets = response?.aggregations["2"].buckets;
        let total = 0;
        for (let i = 0; i < buckets.length; i++) {
            total = total + buckets[i].doc_count;
            summary = buckets.length;
        }
        for (let i = 0; i < buckets.length; i++) {
            let percentage = ((buckets[i].doc_count * 100) / total).toFixed(2)
            // tableObj = {
            //     id: i + 1,
            //     automata_name: buckets[i].key,
            //     count: buckets[i].doc_count,
            //     countPercentage: percentage
            // };
            graphObj = {
                group: buckets[i].key,
                key: buckets[i].key,
                value: buckets[i].doc_count,
            };
            //tableData.push(tableObj);
            graphData.push(graphObj);
            downloadableData.push(tableObj);
        }
        graphData = graphData.slice(0, 10);
    }
    return { graphData, summary };

};

// export async function TopTerminationReasons(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

//     if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
//         let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
//         let formattedData = [];
//         return callPostApi(Constants.GETREPEATEDTERMINATIONBOTS, {
//             'Content-Type': 'application/json'
//         }, bodyJSON)
//             .then(resp => {
//                 formattedData = prepareRepeatedTerminationBots(resp);
//                 return { data: formattedData ? formattedData : [], loader: false };
//             }).catch((error) => {
//                 return { data: null, loader: false };
//             });
//     }
// }

// const prepareRepeatedTerminationBots = (response) => {
//     let tableData = [];
//     let tableObj = {};
//     if (response?.aggregations) {
//         let buckets = response?.aggregations.repeated_termination_bots.buckets;
//         for (let i = 0; i < buckets.length; i++) {
//             let automataNamebucket = buckets[i].automata_name.buckets
//             for (let j = 0; j < automataNamebucket.length; j++) {
//                 let leadPlatformbucket = automataNamebucket[j].lead_platform.buckets
//                 for (let k = 0; k < leadPlatformbucket.length; k++) {
//                     let subAreabucket = leadPlatformbucket[k].sub_area.buckets
//                     for (let l = 0; l < subAreabucket.length; l++) {
//                         let geoNamebucket = subAreabucket[l].geo_name.buckets
//                         for (let m = 0; m < geoNamebucket.length; m++) {
//                             let criticalitybucket = geoNamebucket[m].criticality.buckets
//                             for (let n = 0; n < criticalitybucket.length; n++) {
//                                 let requestedBybucket = criticalitybucket[n].requested_by.buckets
//                                 for (let o = 0; o < requestedBybucket.length; o++) {
//                                     let deiveryModelBucket = requestedBybucket[o].delivery_model.buckets
//                                     for (let p = 0; p < deiveryModelBucket.length; p++) {
//                                         let repeatedTerminationsbucket = deiveryModelBucket[p].repeated_terminations.buckets
//                                         for (let q = 0; q < repeatedTerminationsbucket.length; q++) {
//                                             let scheduleFrequencybucket = repeatedTerminationsbucket[q].schedule_frequency.buckets
//                                             for (let r = 0; r < scheduleFrequencybucket.length; r++) {
//                                                 let lastExecutionbucket = scheduleFrequencybucket[r].last_execution_start_time
//                                                 tableObj = {
//                                                     id: ((i + 1).toString()),
//                                                     'automataName': automataNamebucket[j].key,
//                                                     'leadPlatform': leadPlatformbucket[k].key,
//                                                     'subArea': subAreabucket[l].key,
//                                                     'geoName': geoNamebucket[m].key,
//                                                     'criticality': criticalitybucket[n].key,
//                                                     'requestedBy': requestedBybucket[o].key,
//                                                     'deliveryModel': deiveryModelBucket[p].key,
//                                                     'repeatedTerminations': repeatedTerminationsbucket[q].key,
//                                                     'scheduleFrequency': scheduleFrequencybucket[r].key,
//                                                     'lastExecution': lastExecutionbucket.value_as_string
//                                                 }
//                                             }
//                                         }
//                                     }
//                                 }
//                             }
//                         }
//                     }
//                 }
//             }
//             tableData = tableData.concat(tableObj);
//         }
//     }
//     return tableData;
// };

export async function SchedulerExceptionsCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = 0;
        return callPostApi(Constants.GETEXCEPTIONCLASSIFICATIONOFINCIDENTS, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareDonutChartData(resp);
                return { data: formattedData ? formattedData : 0, loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareDonutChartData = (response) => {
    let buckets = response?.aggregations["2"].buckets;;
    let total = 0;
    let summary = 0;
    if (buckets.length) {
        for (let i = 0; i < buckets.length; i++) {
            total = total + buckets[i]["1"].value;
            if (buckets[i].key === "Scheduler Exception") {
                summary = summary + buckets[i]["1"].value;
            }
        }
    }
    return summary;
}

export async function OnboardAutomataVMCount(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let botsData = '';
        return callPostApi(Constants.GETONBOARDEDBOTS, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                botsData = resp?.aggregations.onboarded_bots.value;
                return { data: botsData ? botsData : 0, loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}




